/* 三國逗陣打 · 武將專屬的畫面（畫面層，只讀模擬狀態；模擬的部分在各武將檔 heroes/<陣營>/<id>.ts）
 * 自訂投射物（牌、騎兵、石）、暫時的城牆、鍾繇「一筆」等地面效果、鄧艾氈球與曹彰騎馬、鍾會偽裝、頭上的牌／棺／盾陣。
 * 每一段的註解標明是哪名武將；要改某名武將的樣子，在這個檔案搜尋他的名字。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const V = SG.View.prototype, K = SG.K, TAU = Math.PI * 2;
const CARD = { blue: ['#7fd8ff', '酥'], red: ['#ff7a5a', '門'], gold: ['#ffd46b', '肋'] };
let W = null; // 目前畫面的世界（畫標記時要用到時間）

// 一張謎題牌：米黃底、彩色邊、中間一個字
function card(ctx, x, y, type, rot, s, glow, alpha) {
  const [col, ch] = CARD[type] || ['#d8cdb5', '謎'];
  ctx.save(); ctx.translate(x, y); ctx.rotate(rot); ctx.scale(s, s);
  if (alpha != null) ctx.globalAlpha = alpha;
  if (glow) { ctx.shadowColor = col; ctx.shadowBlur = 14; }
  ctx.fillStyle = '#f4ead2'; ctx.strokeStyle = col; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(-6, -10); ctx.lineTo(6, -10); ctx.quadraticCurveTo(8, -10, 8, -8); ctx.lineTo(8, 8); ctx.quadraticCurveTo(8, 10, 6, 10);
  ctx.lineTo(-6, 10); ctx.quadraticCurveTo(-8, 10, -8, 8); ctx.lineTo(-8, -8); ctx.quadraticCurveTo(-8, -10, -6, -10); ctx.closePath(); ctx.fill(); ctx.stroke();
  ctx.shadowBlur = 0;
  ctx.strokeStyle = SG.INK || '#1a1a1a'; ctx.lineWidth = 0.8; ctx.strokeRect(-5.5, -7.5, 11, 15);
  ctx.fillStyle = type ? col : '#3a2a20'; ctx.font = '900 10px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (type) { ctx.lineWidth = 2.4; ctx.strokeStyle = 'rgba(20,16,12,.85)'; ctx.strokeText(ch, 0, 0.5); }
  ctx.fillText(ch, 0, 0.5);
  ctx.restore();
}


// 影子用的配色：整身紫黑
function shadowSpec(spec) {
  if (Object.prototype.hasOwnProperty.call(spec, '_shadow')) return spec._shadow;
  const c = {};
  for (const k in spec.c) c[k] = spec.c[k] ? '#2a1640' : spec.c[k];
  spec._shadow = Object.assign(Object.create(spec), { skin: '#3a2456', hair: '#140a20', beardColor: null, eyeColor: '#d8b8ff', c });
  return spec._shadow;
}

// 側面的一匹馬（f 為面向），legs 依時間奔跑
function horse(ctx, x, y, f, time, col, cloth, s) {
  s = s || 1;
  ctx.save(); ctx.translate(x, y); ctx.scale(f * s, s);
  const ph = time * 14, INK = SG.INK || '#1a1a1a';
  ctx.fillStyle = 'rgba(8,8,6,.3)'; ctx.beginPath(); ctx.ellipse(0, 0, 34, 7, 0, 0, TAU); ctx.fill();
  ctx.strokeStyle = INK; ctx.lineWidth = 4; ctx.lineCap = 'round';
  [[-18, 0], [-10, 1.6], [12, 3.1], [20, 4.7]].forEach(([lx, o]) => { const sw = Math.sin(ph + o) * 9; ctx.beginPath(); ctx.moveTo(lx, -30); ctx.lineTo(lx + sw, -2); ctx.stroke(); });
  ctx.fillStyle = col; ctx.lineWidth = 1.6;
  ctx.beginPath(); ctx.ellipse(0, -36, 28, 12, 0, 0, TAU); ctx.fill(); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(18, -42); ctx.lineTo(30, -62); ctx.lineTo(40, -58); ctx.lineTo(34, -48); ctx.lineTo(24, -32); ctx.closePath(); ctx.fill(); ctx.stroke();
  ctx.fillStyle = INK; ctx.beginPath(); ctx.moveTo(-27, -40); ctx.quadraticCurveTo(-40, -36 + Math.sin(ph) * 3, -38, -22); ctx.lineTo(-30, -34); ctx.closePath(); ctx.fill();
  ctx.beginPath(); ctx.moveTo(22, -46); ctx.lineTo(30, -64); ctx.lineTo(26, -50); ctx.closePath(); ctx.fill();
  if (cloth) { ctx.fillStyle = cloth; ctx.fillRect(-12, -48, 20, 10); ctx.strokeRect(-12, -48, 20, 10); }
  ctx.restore();
}
SG.drawHorse = horse;
// 簡化的騎兵／伏兵：馬上一個持槍的人形
function rider(ctx, x, y, f, time, team, foot) {
  const cloth = team === 0 ? '#a93a30' : '#3b5a99', INK = SG.INK || '#1a1a1a';
  if (!foot) horse(ctx, x, y, f, time, '#6a4a30', cloth, 0.8);
  const by = foot ? y : y - 34;
  ctx.save(); ctx.translate(x, by); ctx.scale(f, 1);
  ctx.strokeStyle = INK; ctx.lineWidth = 1.4; ctx.fillStyle = cloth;
  if (foot) { ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(-4, 0); ctx.lineTo(-6 + Math.sin(time * 14) * 5, -18); ctx.moveTo(4, 0); ctx.lineTo(6 - Math.sin(time * 14) * 5, -18); ctx.stroke(); ctx.lineWidth = 1.4; }
  ctx.beginPath(); ctx.moveTo(-7, -14); ctx.lineTo(7, -14); ctx.lineTo(5, -36); ctx.lineTo(-5, -36); ctx.closePath(); ctx.fill(); ctx.stroke();
  ctx.fillStyle = '#e8c49a'; ctx.beginPath(); ctx.arc(0, -42, 6, 0, TAU); ctx.fill(); ctx.stroke();
  ctx.fillStyle = '#8e97a8'; ctx.beginPath(); ctx.arc(0, -45, 6.5, Math.PI, 0); ctx.fill(); ctx.stroke();
  ctx.strokeStyle = '#5a3a22'; ctx.lineWidth = 2.2; ctx.beginPath(); ctx.moveTo(-6, -22); ctx.lineTo(30, -40); ctx.stroke();
  ctx.fillStyle = '#d6dce2'; ctx.beginPath(); ctx.moveTo(30, -40); ctx.lineTo(40, -45); ctx.lineTo(32, -36); ctx.closePath(); ctx.fill();
  ctx.restore();
}

// ---------- 投射物：牌、騎兵 ----------
const drawProjs0 = V.drawProjs;
V.drawProjs = function (ctx, inView) {
  W = this.w;
  const all = this.w.projs, mine = (p) => p.shape === 'card' || p.shape === 'cavalry' || p.shape === 'firewall';
  for (const p of all) { // 滿寵的火牆：橫向一排火焰
    if (p.shape !== 'firewall' || !inView(p.x, p.y, p.rad + 80)) continue;
    const px = -(p.vy / K) / (p.speed || 1), py = (p.vx) / (p.speed || 1), n = Math.max(4, Math.round(p.rad / 16));
    for (let i = 0; i < n; i++) {
      const o = (i / (n - 1) - 0.5) * 2 * p.rad;
      ctx.save(); ctx.translate(p.x + px * o, p.y + py * o * K);
      SG.FX.fire(ctx, { pal: 'fire', small: 0, seed: i * 1.7, s: p.wind ? 1.3 : 1 }, 0.45, this.WS.time + i * 0.21);
      ctx.restore();
    }
  }
  if (!all.some(mine)) return drawProjs0.call(this, ctx, inView);
  for (const p of all) {
    if (p.shape !== 'cavalry' || !inView(p.x, p.y, 200)) continue;
    const f = Math.sign(p.vx) || 1, n = p.foot ? 1 : 3, px = -(p.vy / K) / (p.speed || 1), py = (p.vx) / (p.speed || 1);
    for (let i = 0; i < n; i++) { const o = n > 1 ? (i - 1) * p.rad * 0.7 : 0; rider(ctx, p.x + px * o + (i % 2) * 12, p.y + py * o * K, f, this.WS.time + i * 0.3, p.team, p.foot); }
  }
  for (const p of all) {
    if (p.shape !== 'card' || !p.visual || !inView(p.x, p.y, 60)) continue;
    ctx.save(); ctx.fillStyle = 'rgba(8,8,6,.3)'; ctx.beginPath(); ctx.ellipse(p.x, p.y, 8, 3, 0, 0, TAU); ctx.fill(); ctx.restore();
    card(ctx, p.x, p.homing ? p.y : p.y - 50, p.card || null, p.t * 16 * (p.f || 1), p.card ? 1.35 : 1, !!p.card || !p.homing);
  }
  this.w.projs = all.filter((p) => !mine(p));
  try { drawProjs0.call(this, ctx, inView); } finally { this.w.projs = all; }
};

// 暫時的城牆：滿寵的夯土城牆（雉堞）、李典的宗族盾牆
function drawGate(ctx, g, t, ally, inView) {
  const [x0, y0, x1, y1] = g.seg;
  if (!inView((x0 + x1) / 2, (y0 + y1) / 2, Math.hypot(x1 - x0, y1 - y0) / 2 + 60)) return;
  const life = Math.max(0, Math.min(1, (g.until - t) / 0.4, (t - g.t0) / 0.2));
  ctx.save(); ctx.globalAlpha = life;
  ctx.strokeStyle = ally ? 'rgba(255,214,120,.55)' : 'rgba(181,124,255,.5)'; ctx.lineWidth = 6; ctx.setLineDash([14, 10]);
  ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke(); ctx.setLineDash([]);
  const n = 5;
  for (let i = 0; i < n; i++) {
    const a = (i + 0.5) / n, bx = x0 + (x1 - x0) * a, by = y0 + (y1 - y0) * a, r = 15;
    ctx.strokeStyle = '#3a2a1a'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(bx, by); ctx.lineTo(bx, by - 34); ctx.stroke(); // 靶架
    [['#f3ead6', 1], ['#c23b2e', 0.72], ['#f3ead6', 0.45], ['#c23b2e', 0.2]].forEach(([c, k]) => { ctx.fillStyle = c as string; ctx.beginPath(); ctx.ellipse(bx, by - 46, r * (k as number), r * (k as number), 0, 0, TAU); ctx.fill(); });
    ctx.strokeStyle = SG.INK || '#1a1a1a'; ctx.lineWidth = 1.4; ctx.beginPath(); ctx.ellipse(bx, by - 46, r, r, 0, 0, TAU); ctx.stroke();
  }
  ctx.restore();
}
function drawWall(ctx, wl, T, team, viewTeam) {
  const [x0, y0, x1, y1] = wl.seg, L = Math.hypot(x1 - x0, (y1 - y0) / K), life = Math.min(1, (wl.until - wl.w.t) / 0.5, (wl.w.t - wl.t0) / 0.25);
  const n = Math.max(3, Math.round(L / (wl.kind === 'clan' ? 34 : 40)));
  const pts = []; for (let i = 0; i < n; i++) { const k = (i + 0.5) / n; pts.push([x0 + (x1 - x0) * k, y0 + (y1 - y0) * k]); }
  pts.sort((a, b) => a[1] - b[1]);
  ctx.save(); ctx.globalAlpha = Math.max(0, life);
  for (const [x, y] of pts) {
    if (wl.kind === 'clan') { // 宗族兵：舉大盾的步卒
      ctx.fillStyle = 'rgba(8,8,6,.3)'; ctx.beginPath(); ctx.ellipse(x, y, 16, 5, 0, 0, TAU); ctx.fill();
      ctx.fillStyle = team === 0 ? '#a93a30' : '#3b5a99'; ctx.strokeStyle = SG.INK || '#1a1a1a'; ctx.lineWidth = 1.4;
      ctx.beginPath(); ctx.moveTo(x - 13, y - 48); ctx.lineTo(x + 13, y - 48); ctx.lineTo(x + 13, y - 8); ctx.lineTo(x, y); ctx.lineTo(x - 13, y - 8); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.fillStyle = '#e9d8a6'; ctx.font = '900 12px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('李', x, y - 28);
      ctx.fillStyle = '#8e97a8'; ctx.beginPath(); ctx.arc(x, y - 54, 6, Math.PI, 0); ctx.fill(); ctx.stroke();
    } else { // 夯土城牆一段：牆身＋雉堞
      const h = 46;
      ctx.fillStyle = 'rgba(8,8,6,.32)'; ctx.fillRect(x - 22, y - 2, 44, 8);
      ctx.fillStyle = '#b89a6a'; ctx.strokeStyle = SG.INK || '#1a1a1a'; ctx.lineWidth = 1.4;
      ctx.fillRect(x - 21, y - h, 42, h); ctx.strokeRect(x - 21, y - h, 42, h);
      ctx.fillStyle = '#9a7e52'; ctx.fillRect(x - 21, y - h * 0.45, 42, 3);
      ctx.fillStyle = '#c8aa78';
      for (const cx of [-15, 3]) { ctx.fillRect(x + cx, y - h - 9, 12, 9); ctx.strokeRect(x + cx, y - h - 9, 12, 9); }
    }
  }
  ctx.restore();
}

// ---------- 地面：鍾繇「一筆」 ----------
const drawZones0 = V.drawZones;
V.drawZones = function (ctx, inView) {
  W = this.w;
  for (const wl of SG.MAP.walls || []) if (wl.w === this.w && wl.until > this.w.t) drawWall(ctx, wl, this.WS.time, wl.team, this.team);
  // 李典兵牆推進中
  for (const u of this.w.units) if (u.clan && u.clan.cx != null) {
    const c = u.clan, h = c.w / 2;
    drawWall(ctx, { seg: [c.cx - c.tx * h, c.cy - c.ty * h * K, c.cx + c.tx * h, c.cy + c.ty * h * K], kind: 'clan', w: this.w, until: this.w.t + 1, t0: c.t0 }, this.WS.time, u.team, this.team);
  }
  // 太史慈「持的出城」：一排箭靶（的）
  for (const u of this.w.units) if (u.gate && u.gate.until > this.w.t) drawGate(ctx, u.gate, this.w.t, u.team === this.team, inView);
  // 郭脩「詐降」「歲首刺」的影子：跟本體同一個動作的紫黑色身影
  for (const u of this.w.units) if (u.gxS && u.alive) {
    const a = this.actors.get(u.id);
    if (!a || !a.P) continue;
    for (const s of u.gxS) {
      if (s.until <= this.w.t || !inView(s.x, s.y, 120)) continue;
      const left = s.until - this.w.t;
      ctx.save(); ctx.translate(s.x, s.y);
      ctx.fillStyle = 'rgba(40,10,70,.35)'; ctx.beginPath(); ctx.ellipse(0, 0, 26, 26 * K, 0, 0, TAU); ctx.fill();
      ctx.scale(a.s * u.f, a.s); ctx.globalAlpha = 0.6 * Math.min(1, left / 0.5);
      SG.drawHero(ctx, shadowSpec(u.spec), a.P, this.WS.time * 1000);
      ctx.restore();
    }
  }
  for (const z of this.w.zones) {
    const e = z.x2;
    if (!e || !inView(z.x, z.y, z.r + 80)) continue;
    const T = this.WS.time, life = Math.min(1, z.t / 0.6);
    if (e.flood) { // 江水：藍色水面、漣漪與白浪邊
      ctx.save(); ctx.globalAlpha = life;
      ctx.fillStyle = 'rgba(64,132,196,.5)'; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r, z.r * K, 0, 0, TAU); ctx.fill();
      ctx.strokeStyle = 'rgba(220,240,255,.6)'; ctx.lineWidth = 2.5; ctx.setLineDash([10, 8]); ctx.lineDashOffset = -T * 20; ctx.stroke(); ctx.setLineDash([]);
      for (let i = 0; i < 3; i++) { const k = ((T * 0.5 + i / 3) % 1); ctx.strokeStyle = `rgba(200,230,255,${0.5 * (1 - k)})`; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r * k, z.r * k * K, 0, 0, TAU); ctx.stroke(); }
      ctx.restore(); continue;
    }
    if (e.cage) { // 十面埋伏：外圈十面軍旗
      ctx.save(); ctx.globalAlpha = life;
      ctx.strokeStyle = z.team === this.team ? 'rgba(240,180,60,.7)' : 'rgba(181,124,255,.75)'; ctx.lineWidth = 3; ctx.setLineDash([12, 8]);
      ctx.beginPath(); ctx.ellipse(z.x, z.y, e.cage.R, e.cage.R * K, 0, 0, TAU); ctx.stroke(); ctx.setLineDash([]);
      const col = z.team === 0 ? '#a93a30' : '#3b5a99';
      for (let k = 0; k < 10; k++) {
        const a = (k / 10) * TAU, bx = z.x + Math.cos(a) * e.cage.R, by = z.y + Math.sin(a) * e.cage.R * K, wv = Math.sin(T * 6 + k) * 3;
        ctx.strokeStyle = '#3a2a1a'; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.moveTo(bx, by); ctx.lineTo(bx, by - 70); ctx.stroke();
        ctx.fillStyle = col; ctx.strokeStyle = SG.INK || '#1a1a1a'; ctx.lineWidth = 1.2;
        ctx.beginPath(); ctx.moveTo(bx, by - 70); ctx.lineTo(bx + 26, by - 66 + wv); ctx.lineTo(bx + 24, by - 46 + wv); ctx.lineTo(bx, by - 50); ctx.closePath(); ctx.fill(); ctx.stroke();
        ctx.fillStyle = '#f3ead6'; ctx.font = '900 11px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('伏', bx + 12, by - 58 + wv * 0.6);
      }
      ctx.restore(); continue;
    }
    if (!e.seg) continue;
    const [x0, y0, x1, y1] = e.seg;
    if (!inView((x0 + x1) / 2, (y0 + y1) / 2, Math.hypot(x1 - x0, y1 - y0) / 2 + 60)) continue;
    const grow = Math.min(1, ((z.dur0 || 6) - z.t) / 0.35); // 先一筆寫出去，最後淡掉
    const ex = x0 + (x1 - x0) * grow, ey = y0 + (y1 - y0) * grow;
    const ally = z.team === this.team;
    ctx.save(); ctx.globalAlpha = 0.85 * life; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    // 邊緣的陣營光
    ctx.strokeStyle = ally ? 'rgba(240,180,60,.3)' : 'rgba(181,124,255,.3)'; ctx.lineWidth = e.w * 1.05;
    ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(ex, ey); ctx.stroke();
    // 墨：一整塊收尖的筆畫（起筆重、收筆細），邊緣微微起伏，再加兩道飛白
    const L = Math.hypot(ex - x0, (ey - y0) / K) || 1, ux = (ex - x0) / L, uy = (ey - y0) / K / L, px = -uy, py = ux;
    const segs = 18, left = [], right = [];
    for (let i = 0; i <= segs; i++) {
      const a = i / segs, hw = e.w * 0.5 * (a < 0.08 ? 0.55 + a * 5 : 1 - 0.65 * Math.pow(a, 1.6)) * (1 + 0.06 * Math.sin(i * 2.7 + z.x));
      const cx = x0 + ux * L * a, cy = y0 + uy * L * a * K;
      left.push([cx + px * hw, cy + py * hw * K]); right.push([cx - px * hw, cy - py * hw * K]);
    }
    ctx.fillStyle = 'rgba(18,16,22,.9)';
    ctx.beginPath(); left.forEach((q, i) => (i ? ctx.lineTo(q[0], q[1]) : ctx.moveTo(q[0], q[1])));
    for (let i = right.length - 1; i >= 0; i--) ctx.lineTo(right[i][0], right[i][1]);
    ctx.closePath(); ctx.fill();
    ctx.strokeStyle = 'rgba(244,234,210,.28)'; ctx.lineWidth = 1.4; ctx.lineCap = 'round';
    for (const off of [-0.22, 0.15]) {
      const ox = px * e.w * off, oy = py * e.w * off * K;
      ctx.beginPath(); ctx.moveTo(x0 + ox + ux * L * 0.3, y0 + oy + uy * L * 0.3 * K); ctx.lineTo(x0 + ox + ux * L * 0.85, y0 + oy + uy * L * 0.85 * K); ctx.stroke();
    }
    ctx.restore();
  }
  return drawZones0.call(this, ctx, inView);
};

// ---------- 角色本身：鄧艾滾成氈球、曹彰騎馬 ----------
const actorFor0 = V.actorFor;
V.actorFor = function (u) {
  if (u.disguise && u.disguise.spec) { // 鍾會「效人書」：換成被偽裝那名武將的外觀
    const px = Object.create(u); px.id = 'dg' + u.id + ':' + u.disguise.spec.id; px.spec = u.disguise.spec;
    if (u.team !== this.team) px.team = this.team; // 對敵方來說他看起來像自己人
    return actorFor0.call(this, px);
  }
  const a = actorFor0.call(this, u);
  if (u.kind !== 'hero' || a.heroFx) return a;
  a.heroFx = true;
  const d0 = a.draw, view = this;
  a.draw = function (ctx, tm) {
    const w = view.w, time = view.WS.time;
    if (u.rollT > w.t) { // 氈球：滾動的褐色毯捲
      ctx.save(); ctx.globalAlpha = this.alpha == null ? 1 : this.alpha;
      ctx.fillStyle = 'rgba(8,8,6,.3)'; ctx.beginPath(); ctx.ellipse(u.x, u.y, 26, 8, 0, 0, TAU); ctx.fill();
      ctx.translate(u.x, u.y - 26); ctx.rotate(time * 14 * u.f);
      ctx.fillStyle = '#8a6a44'; ctx.strokeStyle = SG.INK || '#1a1a1a'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(0, 0, 26, 0, TAU); ctx.fill(); ctx.stroke();
      ctx.strokeStyle = '#5a4026'; ctx.lineWidth = 3; ctx.beginPath(); ctx.arc(0, 0, 17, 0, Math.PI * 1.4); ctx.stroke(); ctx.beginPath(); ctx.arc(0, 0, 8, Math.PI, Math.PI * 2.3); ctx.stroke();
      ctx.restore(); return;
    }
    if (u.mounted && u.alive) {
      horse(ctx, u.x, u.y, u.f, u.loop === 'run' || u.loop === 'walk' ? time : 0, '#7a4a2a', '#3b5a99', 1);
      const y0 = this.y; this.y -= 26;
      try { d0.call(this, ctx, tm); } finally { this.y = y0; }
      return;
    }
    d0.call(this, ctx, tm);
  };
  return a;
};

// 偽裝：敵方看到的名牌、血條顏色都是被偽裝的那個人
const drawBar0 = V.drawBar;
V.drawBar = function (ctx, u) {
  if (u.disguise && u.team !== this.team) { const px = Object.create(u); px.name = u.disguise.name; px.team = this.team; return drawBar0.call(this, ctx, px); }
  if (u.disguise) { const px = Object.create(u); px.name = `${u.name}（偽：${u.disguise.name}）`; return drawBar0.call(this, ctx, px); }
  return drawBar0.call(this, ctx, u);
};

// ---------- 頭上：牌、棺、盾陣 ----------
const drawMark0 = SG.drawMark;
SG.drawMark = function (ctx, u, time) {
  if (drawMark0) drawMark0(ctx, u, time);
  if (u.kind !== 'hero' || !W) return;
  const s = (u.spec && u.spec.size) || 1, hy = u.y - 168 * s;
  if (u.cardSel) { // 輪流亮牌：三張扇開，亮著的那張放大
    const shown = SG.cardShown(W, u);
    ['blue', 'red', 'gold'].forEach((t, i) => { if (t !== shown) card(ctx, u.x + (i - 1) * 18, hy + 4, t, (i - 1) * 0.25, 0.9, false, 0.55); });
    card(ctx, u.x + (['blue', 'red', 'gold'].indexOf(shown) - 1) * 18, hy - 4, shown, 0, 1.5, true);
  } else if (u.card) card(ctx, u.x, hy - 4 + Math.sin(time * 5) * 3, u.card.type, Math.sin(time * 3) * 0.15, 1.5, true);
  if (u.coffinT > W.t) { // 抬櫬：背後一口黑棺
    ctx.save(); ctx.translate(u.x - u.f * 18, u.y - 70 * s); ctx.rotate(-u.f * 0.25);
    ctx.fillStyle = '#2a1a14'; ctx.strokeStyle = '#8a2a22'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(-9, -34); ctx.lineTo(9, -34); ctx.lineTo(12, 30); ctx.lineTo(-12, 30); ctx.closePath(); ctx.fill(); ctx.stroke();
    ctx.fillStyle = '#c23b2e'; ctx.font = '900 11px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('死', 0, -8); ctx.fillText('戰', 0, 8);
    ctx.restore();
    ctx.save(); ctx.globalAlpha = 0.35 + 0.15 * Math.sin(time * 8); ctx.strokeStyle = '#c23b2e'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.ellipse(u.x, u.y, 34, 34 * K, 0, 0, TAU); ctx.stroke(); ctx.restore();
  }
  if (u.parry && u.parry.until > W.t) { // 識破：架槍的光
    ctx.save(); ctx.strokeStyle = '#c9d8ff'; ctx.lineWidth = 3; ctx.globalAlpha = 0.8;
    ctx.beginPath(); ctx.moveTo(u.x - 26 * u.f, u.y - 90 * s); ctx.lineTo(u.x + 26 * u.f, u.y - 30 * s); ctx.stroke();
    ctx.fillStyle = '#c9d8ff'; ctx.font = '900 16px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('識', u.x, hy + 10);
    ctx.restore();
  }
  const tag = (ch, col, dy) => { ctx.save(); ctx.fillStyle = 'rgba(12,14,20,.85)'; ctx.beginPath(); ctx.arc(u.x + 36, hy + 22 + (dy || 0), 11, 0, TAU); ctx.fill(); ctx.strokeStyle = col; ctx.lineWidth = 2; ctx.stroke(); ctx.fillStyle = col; ctx.font = '900 12px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(ch, u.x + 36, hy + 22.5 + (dy || 0)); ctx.restore(); };
  if (u.mcT > W.t) tag('叛', '#c9a2ff'); // 矯詔：倒戈中
  if (u.stolen && u.stolen.until > W.t) tag('禪', '#ff8a5a'); // 受禪：手上有奪來的大招
  if (u.bean) tag('萁', '#ff8a3a', -24); // 煮豆燃萁：走太多就爆
  if (u.sshieldT > W.t) tag('伏', '#ffe9a8', 24); // 博望識伏：技能護盾
  if (u.bulwarkT > W.t) { // 江夏屏障：一圈大盾
    ctx.save();
    for (let i = 0; i < 8; i++) {
      const a = i / 8 * TAU + time * 0.3, px = u.x + Math.cos(a) * 46, py = u.y + Math.sin(a) * 46 * K;
      ctx.fillStyle = '#2f5a7a'; ctx.strokeStyle = '#c9e8ff'; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.moveTo(px - 7, py - 26); ctx.lineTo(px + 7, py - 26); ctx.lineTo(px + 7, py - 4); ctx.lineTo(px, py + 2); ctx.lineTo(px - 7, py - 4); ctx.closePath(); ctx.fill(); ctx.stroke();
    }
    ctx.restore();
  }
};
